module.exports = __webpack_public_path__ + "media/images/emblems/GW-TG-Kradolf-Schoenenberg-5baa644053c49dabdb48d27852deffe9.png";